/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { Provider } from "~/generated/graphql";
import { CostCell } from "~/components/Cost";
import { CustomCell } from "~/components/Tables/Cells";
import { ProviderIcons } from "~/components/Tables/Columns/ProviderIcons";
import { ROUTES } from "~/routing/routes";

type EstateRecord = {
  id: string;
  nid: string;
  provider: Provider;
  type?: string;
  name: string;
  account: string;
  location: string;
  environment: {
    name: string;
    nid: string;
    application: {
      nid: string;
      name: string;
    };
  };
  benefit: string;
};

export const EstateRecordsColumns = [
  {
    Header: "Resource Type / Resource Name",
    accessor: "provider",
    disableSortBy: true,
    width: "20%",
    Cell: ({ row }: Cell<EstateRecord>) => {
      const { type, provider } = row.original;

      return (
        <FlexContainer>
          <ProviderIcons provider={provider} type={type} />
          <FlexContainer
            marginLeft={theme.spacing.spacing04}
            justifyContent="center"
            direction="column"
            alignItems="center"
          >
            <CustomCell
              name={row.original.name}
              url={`${ROUTES.estateRecords.index}/${row.original.nid}`}
              description={row.original.type}
            />
          </FlexContainer>
        </FlexContainer>
      );
    },
  },
  {
    Header: "Account / Region",
    accessor: "account",
    disableSortBy: true,
    Cell: ({ row }: Cell<EstateRecord>) => (
      <CustomCell
        name={row.original.account}
        url={`${ROUTES.estateRecords.index}?query=${row.original.account}`}
        description={row.original.location}
      />
    ),
  },
  {
    Header: "Application / Environment",
    accessor: "type",
    disableSortBy: true,
    Cell: ({ row }: Cell<EstateRecord>) => (
      <CustomCell
        name={row.original.environment?.application?.name || ""}
        url={`${ROUTES.applications.index}/${row.original.environment?.application?.nid}`}
        description={row.original.environment?.name || ""}
        descriptionUrl={`${ROUTES.applications.index}/${row.original.environment?.application?.nid}/${row.original.environment?.nid}`}
      />
    ),
  },
  {
    Header: "Benefit",
    accessor: "benefit",
    disableSortBy: true,
    Cell: ({ row }: Cell<EstateRecord>) => (
      <CostCell value={row.original.benefit} />
    ),
  },
];
